/**
 * Estilo padrão (tema claro) para o react-select — não é um componente
 * Chakra, então não segue o resto da tela sozinho. Valores conferidos via
 * comparação de estilos computados contra um `<Select size="sm">` nativo do
 * Chakra nesse projeto — que usa uma paleta `gray` customizada
 * (src/styles/theme/light.ts), bem diferente da paleta padrão do Chakra.
 * Não copiar tons "gray.xxx" de outro projeto Chakra sem checar
 * src/styles/theme/light.ts primeiro.
 *
 * Tipado como `any` nos parâmetros porque a tipagem de estilos do
 * react-select@4 (CSSProperties) não bate estruturalmente com um objeto
 * literal solto — mesma solução já usada em Global/Select para esse lib.
 */
export const reactSelectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    backgroundColor: 'transparent',
    borderColor: state.isFocused ? '#3182CE' : '#353646',
    borderWidth: '1px',
    borderRadius: '0.125rem',
    boxShadow: state.isFocused ? '0 0 0 1px #3182CE' : 'none',
    minHeight: '2rem',
    height: '2rem',
    fontSize: '0.875rem',
  }),
  valueContainer: (base: any) => ({
    ...base,
    height: '2rem',
    padding: '0 0.75rem',
  }),
  singleValue: (base: any) => ({ ...base, color: '#333333' }),
  input: (base: any) => ({ ...base, color: '#333333', margin: 0, padding: 0 }),
  placeholder: (base: any) => ({ ...base, color: '#333333' }),
  menu: (base: any) => ({ ...base, backgroundColor: '#FFFFFF' }),
  option: (base: any, state: any) => {
    let backgroundColor = 'transparent';
    if (state.isSelected) backgroundColor = '#3182CE';
    else if (state.isFocused) backgroundColor = '#EEEEF2';

    return {
      ...base,
      backgroundColor,
      color: state.isSelected ? '#FFFFFF' : '#333333',
      cursor: 'pointer',
    };
  },
  clearIndicator: (base: any) => ({
    ...base,
    color: '#616480',
    padding: '4px',
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    color: '#616480',
    padding: '4px',
  }),
  indicatorsContainer: (base: any) => ({ ...base, height: '2rem' }),
  indicatorSeparator: () => ({ display: 'none' }),
};
